const { default: axiosIns } = require('@/libs/axios')

const ConfigurationItemsService = {
  // GET - ConfigurationApiController
  async getAdminConfigurations() {
    return axiosIns.get('/admin/configurations').then(response => response.data)
  },
  // POST - ConfigurationApiController
  async createConfiguration(model) {
    return axiosIns.post('/admin/configurations', model).then(response => response.data)
  },
  // PUT - ConfigurationApiController
  async updateConfiguration(configurationId, model) {
    return axiosIns.put(`/admin/configurations/${configurationId}`, model).then(response => response.data)
  },
}
export default ConfigurationItemsService
